import React from 'react';

import styled from 'styled-components';

type DotProps = {
    $isActive: boolean;
};

const Dot = styled.span<DotProps>`
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${(props) => (props.$isActive ? 'var(--icon_primary_main_default)' : 'var(--icon_primary_main_disabled)')};
`;

interface PasscodeDotProps {
    currentLength?: number;
    dotIndex: number;
}

const PasscodeDot: React.FC<PasscodeDotProps> = ({ currentLength = 0, dotIndex }) => <Dot $isActive={currentLength >= dotIndex} />;

export default PasscodeDot;
